import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const DEBUG = process.env.NODE_ENV === 'development'

const state = {
  user: {
    authenticated: false,
    data: {}
  },
}

const mutations = {
  AUTHENTICATE_USER(state, user) {
    state.user.authenticated = true
    state.user.data = user
  },
  LOGOUT_USER(state) {
    state.user.data = {}
    state.user.authenticated = false
  }
}

const actions = {
  logoutUser({commit}) {
    commit('LOGOUT_USER')
  },
  authenticateUser({commit}, user) {
    commit('AUTHENTICATE_USER', user)
  }
}


export default new Vuex.Store({
  state,
  mutations,
  actions,
  strict: DEBUG
})



// WEBPACK FOOTER //
// ./src/store/index.js